<div class="align-items-center row h-100 to-left-1 {{(['ENABLED', 'UPDATED', 'DELETED', 'PAUSED'].includes(params.data.status)?'cursor-pointer':'')}}
{{(params.data.status === 'PAUSED') ?'faded':''}}" (click)="$event.stopPropagation(); !innerClicked && routeToDetails()">

    <ng-container  *ngIf="(params.data.nextSyncInfo !== undefined)">

            <div class= "m-r-13" *ngIf="(isOrgAdmin || params.data.userId == userId) &&  !(params.data.nextSyncInfo === 'Pending' ||
            params.data.nextSyncInfo === 'Updated' ||
            params.data.nextSyncInfo === 'Sync in progress' ||
            params.data.nextSyncInfo === 'Attempting to start' ||
            params.data.nextSyncInfo === '-/-' )" (click)="$event.stopPropagation(); innerClicked = true; startSource(params.data)">
            <span class="sync-now line-h">
                <i class="cloud-icon"></i>
                <span>
                    Sync now
                </span>
            </span>
        </div>

        <div class="line-h-20">
            <div class="label-05"
                *ngIf="!(params.data.nextSyncInfo === 'Attempting to start' ||
                params.data.nextSyncInfo === 'Pending' ||
                params.data.nextSyncInfo === 'Updated' ||
                params.data.nextSyncInfo === 'Scheduled' ||
                params.data.nextSyncInfo === 'Sync in progress' ||
                params.data.nextSyncInfo === '-/-')">Sync will start</div>
            <div class="text-strong-2 text-truncate {{(params.data.nextSyncInfo === 'Pending' || params.data.nextSyncInfo === 'Updated')?'pending-updated':''}}
                {{(params.data.nextSyncInfo === 'Attempting to start' || params.data.nextSyncInfo === 'Sync in progress')?'cus-wdth-sync':''}}">
                <span
                *ngIf="!(params.data.nextSyncInfo === 'Attempting to start' ||
                params.data.nextSyncInfo === 'Pending' ||
                params.data.nextSyncInfo === 'Updated' ||
                params.data.nextSyncInfo === 'Scheduled' ||
                params.data.nextSyncInfo === 'Sync in progress' ||
                params.data.nextSyncInfo === '-/-')">After</span> {{params.data.nextSyncInfo}}
                <span class="loading-dots"
                    *ngIf="params.data.nextSyncInfo === 'Sync in progress' ||
                    params.data.nextSyncInfo === 'Attempting to start'"></span></div>
        </div>

    </ng-container>

    <span class="loading-dots" *ngIf="(params.data.nextSyncInfo === undefined)">Loading</span>




</div>
